module.exports = __webpack_public_path__ + "static/img/kristengrau_circle150.7f65593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/kristengrau_circle150.png
// module id = O6if
// module chunks = 0